import React from 'react';
import styles from './RelatedOrganizations.module.scss';
import { useTranslation } from 'react-i18next';
import MTLS from 'assets/img/logos/MTLSLogo.png';
import AliceCarousel from 'react-alice-carousel';
import { useQuery } from '@tanstack/react-query';
import { GetRelatedOrganization } from './relatedOrganization.api';
import { BASE_URL } from 'utils/constants';

export default function RelatedOrganizations() {
    const { t, i18n } = useTranslation();
    const locale = i18n.language || 'ar';
    React.useEffect(() => {
        var localStoreVar = localStorage.getItem('locale');
        i18n.changeLanguage(localStoreVar);
    }, []);

    const { data } = useQuery(
        [
            'related-organizations',
            {
                locale: i18n.language,
            },
        ],
        () => GetRelatedOrganization(i18n.language),
        { keepPreviousData: true },
    );
    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 4, itemsFit: 'fill' },
    };
    return (
        <>
            {data?.data && data?.data?.length > 0 &&
                < div className="container_max">
                    <div className={styles.relatedTitle}>{t('Related Organizations')}</div>
                    <div className={styles.relatedWrap}>
                        <AliceCarousel
                            className="carousel"
                            infinite
                            mouseTracking
                            disableDotsControls
                            responsive={responsive}
                            renderPrevButton={() => {
                                return <div className={styles.prevButton}>{'<'}</div>
                            }}
                            renderNextButton={() => {
                                return <div className={styles.nextButton}>{'>'}</div>
                            }}
                        >
                            {data?.data?.map((item, i) => {
                                return (
                                    <div key={i} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                                        <a
                                            href={item?.attributes?.Link}
                                            target="_blank"
                                            rel="noreferrer"
                                            className={styles.relatedLink}
                                        >
                                            < img
                                                src={BASE_URL + item?.attributes?.Logo?.data?.attributes?.url}
                                                alt="logo for Related Organization"
                                                className={styles.relatedImage}
                                            />
                                        </a>
                                    </div>
                                )
                            })}
                        </AliceCarousel>
                    </div>
                    <div className={`${styles.lastUpdate}`}>{t('Last Update Date For Page Content :')} 16/07/2025 1:30 {t('Saudi Arabia Time')}</div>
                </div >
            }
        </>
    );
}
